<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'Notification',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'success',
      validator: (value: string) => ['success', 'error'].includes(value),
    },
  },
});
</script>

<template>
  <transition name="slide-fade">
    <div
      v-if="show"
      :class="[
        'fixed bottom-4 right-4 px-4 py-2 rounded-lg shadow-lg ',
        type === 'success' ? 'bg-green-500 text-white' : 'bg-red-500 text-white',
      ]"
      style="z-index: 99999;"
    >
      {{ message }}
    </div>
  </transition>
</template>

<style scoped lang="scss">
.slide-fade-enter-active {
  transition: all 0.3s ease-out;
}

.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
  transform: translateX(20px);
  opacity: 0;
}
</style>
